import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '../../lib/utils'

const badgeVariants = cva(
  'inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-[10px] font-semibold transition-colors border',
  {
    variants: {
      variant: {
        default:     'border-transparent bg-[#2ECC71] text-[#0d1a0f]',
        secondary:   'border-[var(--border)] bg-[var(--bg-raised)] text-[var(--text-secondary)]',
        accent:      'border-[rgba(46,204,113,0.3)] bg-[rgba(46,204,113,0.1)] text-[#2ECC71]',
        destructive: 'border-[rgba(239,68,68,0.2)] bg-[rgba(239,68,68,0.1)] text-[#EF4444]',
        warning:     'border-[rgba(245,158,11,0.3)] bg-[rgba(245,158,11,0.06)] text-[#F59E0B]',
        outline:     'border-[var(--border)] bg-transparent text-[var(--text-secondary)]',
        info:        'border-[rgba(99,102,241,0.3)] bg-[rgba(99,102,241,0.1)] text-[#6366f1]',
      },
    },
    defaultVariants: { variant: 'default' },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />
}

export { Badge, badgeVariants }
